import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setToken } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { username: u, password: p });
      setToken(data.token);
      toast.success(`Welcome, ${data.username}`);
      nav("/admin/gallery");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="section px-6 lg:px-10 min-h-[70vh] flex items-center" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Lock className="w-10 h-10 text-[#FF5722]" />
        <div className="eyebrow mt-6">Restricted</div>
        <h1 className="font-display text-5xl tracking-tighter mt-2">Admin Sign-In</h1>
        <p className="text-zinc-400 mt-3 text-sm">Access the gallery and lead inbox.</p>

        <form onSubmit={submit} className="mt-10 space-y-5 border border-white/10 p-8 bg-[#0B0B0D]" data-testid="admin-login-form">
          <div>
            <Label className="text-xs uppercase tracking-widest text-zinc-400 mb-2 block">Username</Label>
            <Input value={u} onChange={e => setU(e.target.value)} required data-testid="admin-username" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-zinc-400 mb-2 block">Password</Label>
            <Input type="password" value={p} onChange={e => setP(e.target.value)} required data-testid="admin-password" />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="admin-submit">
            {busy ? "Signing In..." : "Sign In"} <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
